import { colors } from '@gitbook/react-uikit';

/**
 * The interface for rendering color options in a palette
 */
export interface ColorPickerOption {
    key: string;
    color: string;
    title: string;
}

/**
 * Default color options to render the palette
 * for changing the color of selected text in the Content Editor.
 */
export const colorPickerDefaultBold: ColorPickerOption[] = [
    { key: 'blue', color: colors.primary.base, title: 'Blue' },
    { key: 'purple', color: colors.violet.base, title: 'Purple' },
    { key: 'orange', color: colors.orange.base, title: 'Orange' },
    { key: 'red', color: colors.scarlet.base, title: 'Red' },
    { key: 'yellow', color: colors.YELLOW, title: 'Yellow' },
    { key: 'green', color: colors.green.base, title: 'Green' },
];

export const colorPickerDefaultLight: ColorPickerOption[] = [
    { key: 'blue', color: '#89C6DA4D', title: 'Blue' },
    { key: 'purple', color: '#DAD4FF4D', title: 'Purple' },
    { key: 'orange', color: '#FFDCBC4D', title: 'Orange' },
    { key: 'red', color: '#FFCCCB4D', title: 'Red' },
    { key: 'yellow', color: '#FFF0854D', title: 'Yellow' },
    { key: 'green', color: '#91EABF4D', title: 'Green' },
];
